import React from 'react';
import Topheader from '../topheader/Topheader';

import Navcivil from '../navbar/Navcivil';
import About from '../about/about';
import Project from '../Project/Project';
import Footer from "../footer/Footer";
import Ourproject from "../Ourproject/Ourproject";
import Ourservices from '../ourservices/Ourservices';
import Contact from '../contact/Contact';
import Cproject from '../Cproject/Cproject';
import Testimonial from '../testimonial/Testimonial';

import Gallery from "../gallery/galley";
import Galleryy from '../gallery/Galleryy';




function Servicesconstruction() {
  return (
    <>
      <Topheader />  
      <Navcivil />
      <Ourproject />   
  
    <About/>
    <Ourservices/>
      <Project />
      <Cproject/>
      <Galleryy/>
     
      <Testimonial/>
    
      <Footer/>
   
    </>
  );
}

export default Servicesconstruction;
